import ServicePageTemplate from "@/components/landing/ServicePageTemplate";
export default function MecanicaPage() { return <ServicePageTemplate slug="mecanica" />; }
